import axios, {withRetry} from './axios'
import { DEVELOPMENT } from "../utils";


export async function getCompanies(): Promise<string[]> {
  if (process.env.REACT_APP_MODE === DEVELOPMENT) {
    return fakeCompanies
  }
  
  const res = await axios.get('/companies')
  const companies = res.data.data.sort()

  return companies
}

var fakeCompanies = ['SbertTech', 'Sber', 'Yandex', 'Ozon', 'Avito', 'VK']